import { RenderElementProps } from 'slate-react';
import { HighlightElement as HighlightElementNode } from 'slate/types/slate';

export const HighlightElement = ({ attributes, children, element }: RenderElementProps) => {
  const highlight = element as HighlightElementNode;
  return (
    <span {...attributes} id={highlight.id} className={highlight.highlighted ? 'layout-leaf-comment' : ''}>
      {children}
    </span>
  );
};
